import { TaxoSyllabusStatus } from '@/kontent/taxonomies'
import { Elements } from '@kontent-ai/delivery-sdk'
import clsx from 'clsx'
export type StatusTagProps = {
	status: Elements.TaxonomyElement<TaxoSyllabusStatus>
	fromDate?: string
}

const SYLLABUS_STATUS_CLASSNAMES = {
	// (blue-04)
	cbedfd: 'text-nsw-brand-dark border-nsw-brand-dark',
	// nsw-brand-dark (blue-01)
	'002664': 'text-white border-nsw-brand-dark',
	c95000: 'text-white border-nsw-orange-01',
	// Teach in Year 11
	'8ce0ff': 'text-nsw-brand-dark border-nsw-brand-dark',
	// Under development
	ebebeb: 'text-nsw-brand-dark border-nsw-brand-dark',
	// nsw-orange-02
	f3631b: 'text-white border-nsw-orange-01',
	// Teach in year 12 (blue-02)
	'146cfd': 'text-white border-nsw-brand-dark',
	// Under consultation (red-04)
	ffe6ea: 'text-nsw-red-01 border-nsw-red-01',
	// Outgoing / Final HSC Exam (red-03)
	ffb8c1: 'text-nsw-red-01 border-nsw-red-01',
}

function StatusTag({ status, fromDate }: StatusTagProps) {
	if (!status?.value?.length) return null
	const yearLabel = fromDate ? `${new Date(fromDate).getFullYear()}` : ''

	const statusCodename = status.value[0]?.codename
	const statusName = status.value[0]?.name

	const [_, backgroundColor] = statusCodename?.split('_') || []

	let label = `${statusName}`
	if (yearLabel) {
		label += ` ${yearLabel}`
	} else {
		label = label.replace(' from', '')
	}

	return (
		<div
			className={clsx(
				'flex-shrink-0 px-4 py-[3px] border rounded-full inline-flex text-[14px] leading-[19px] bg-nsw-off-white',
				SYLLABUS_STATUS_CLASSNAMES[backgroundColor],
			)}
			style={{
				backgroundColor: '#' + backgroundColor,
			}}
		>
			{label}
		</div>
	)
}

export default StatusTag
